import {
  FETCH_SLACK_CHANNELS_REQUEST,
  FETCH_SLACK_CHANNELS_SUCCESS,
  FETCH_SLACK_CHANNELS_FAILURE,
  CREATE_SLACK_CHANNEL_REQUEST,
  CREATE_SLACK_CHANNEL_SUCCESS,
  CREATE_SLACK_CHANNEL_FAILURE,
  UPDATE_SLACK_CHANNEL_REQUEST,
  UPDATE_SLACK_CHANNEL_SUCCESS,
  UPDATE_SLACK_CHANNEL_FAILURE,
  DELETE_SLACK_CHANNEL_REQUEST,
  DELETE_SLACK_CHANNEL_SUCCESS,
  DELETE_SLACK_CHANNEL_FAILURE,
  SET_SLACK_CHANNEL_MODAL,
  CLEAR_SLACK_CHANNEL_ERRORS,
} from './constants'

const initialState = {
  channels: [],
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  modal: {
    show: false,
    mode: 'create', // 'create' or 'edit'
    data: null,
  },
}

const slackChannelsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SLACK_CHANNELS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case FETCH_SLACK_CHANNELS_SUCCESS:
      return {
        ...state,
        loading: false,
        channels: action.payload || [],
        error: null,
      }
    case FETCH_SLACK_CHANNELS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case CREATE_SLACK_CHANNEL_REQUEST:
      return {
        ...state,
        createLoading: true,
        error: null,
      }
    case CREATE_SLACK_CHANNEL_SUCCESS:
      return {
        ...state,
        createLoading: false,
        error: null,
      }
    case CREATE_SLACK_CHANNEL_FAILURE:
      return {
        ...state,
        createLoading: false,
        error: action.payload,
      }

    case UPDATE_SLACK_CHANNEL_REQUEST:
      return {
        ...state,
        updateLoading: true,
        error: null,
      }
    case UPDATE_SLACK_CHANNEL_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        error: null,
      }
    case UPDATE_SLACK_CHANNEL_FAILURE:
      return {
        ...state,
        updateLoading: false,
        error: action.payload,
      }

    case DELETE_SLACK_CHANNEL_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        error: null,
      }
    case DELETE_SLACK_CHANNEL_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        error: null,
      }
    case DELETE_SLACK_CHANNEL_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload,
      }

    case SET_SLACK_CHANNEL_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action.payload,
        },
      }

    case CLEAR_SLACK_CHANNEL_ERRORS:
      return {
        ...state,
        error: null,
      }

    default:
      return state
  }
}

export default slackChannelsReducer
